define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Action",
    "csi/def/ViewRef",
    "csi/heading/Ref",
    "csi/xml",
    "csi/xml/Query",
    "./SelectSetHelper"
], function(declare,lang,Action,ViewRef,Ref,xml,Query,SelectSetHelper) {

    return declare(Ref, {
        //TODO: use applyActionFilters instead
        _getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
            // summary: filter DP template of the appropriate type.
            var parent = ctx.getParent();
            var node = ctx.getNode();

            ctx.view.refreshHeadingStore(h);

            return lang.mixin(new Action(), {
                //urlContext: ctx.getNodeURL(),
                m_fixedQuery: new Query()
                    .Attr("Active", xml.OP_EQUALS, true)
                    .Attr("IsSupplierSpecific", xml.OP_EQUALS, false)
                    .Attr("TemplateType", xml.OP_EQUALS, "DataPackageContainerType:"+SelectSetHelper.getSubtypeName(node)),
                m_viewRef: lang.mixin(new ViewRef(), {
                    m_id: "DataPackageTemplates",
                    m_url: "centric://APPAREL/SizeChartAdmin"
                })
            });
        }
    });
});